import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const HIDE_EPICS_KEY_PREFIX = 'gh.epicShownOnRapidBoard.';
const storageProvider = createLocalStorageProvider('', false);

export function getHideEpics(boardId: string | number): boolean {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		return storageProvider.get(`${HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
	}
	return localStorage.getItem(`${HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
}

export function setHideEpics(boardId: string | number, hideEpics: boolean) {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		storageProvider.set(`${HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
	} else {
		localStorage.setItem(`${HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
	}
}
